import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import withStyles from '../styles/withStyles'
import Typography from 'components/Typography'

export const styles = theme => ({
  root: {
    counterReset: 'li',

    '& a': {
      color: theme.palette.text.primary,
    },

    '& ol': {
      listStyle: 'none',
      paddingLeft: 0,

      '& li': {
        counterIncrement: 'li',
        // display: 'inline-block',
        paddingBottom: 5,
        paddingLeft: 36,
        ...theme.typography.body2,
        lineHeight: '1.8 !important',
        textTransform: 'uppercase',
        position: 'relative',
        '&::before': {
          content: 'counter(li) ".0"',
          position: 'absolute',
          left: 0,
          color: theme.palette.purple[500],
          fontWeight: theme.typography.fontWeightMedium,
        },
        '& > a': {
          display: 'initial',
          borderBottom: `3px solid ${theme.palette.purple[500]}`,
          paddingBottom: 2,
        },
      },
      '& li + *': {
        marginTop: theme.utils.unit * 4,
      },
    },
  },
})

const WPList = props => {
  const { children, classes, className, ...other } = props

  return (
    <Typography
      component="div"
      className={classnames(classes.root, className)}
      {...other}
    >
      {children}
    </Typography>
  )
}

WPList.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
}

WPList.uiName = 'WPList'

export default withStyles(styles)(WPList)
